export const UNAUTHORIZED_CODE = [401];
